import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
import ReactTable from "react-jquery-datatables";
import Idle from "react-idle";
import IdleTimer from 'react-idle-timer';
import { onActive, onIdle } from './config/Idle';
import CommonHeader  from './components/CommonHeader/CommonHeader'
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import tokenService from './components/Common/tokenDecoder';  
import Login from './components/Auth/Login'

var serviceUrl = config.get('apidomain');
var idleTimeMinutes = config.get('idleTimeOut');


export default class App extends Component {
    displayName = App.name

    componentWillMount() {
        var codes;
         
        this.idleTimer = null
        this.onActive = onActive.bind(this)
        this.onIdle = onIdle.bind(this)
    }
 

    render() {
        var isTokenExists = tokenService.isTokenExists();

        if(isTokenExists){

            var isFirstLogin = tokenService.isFirstLogin().toLowerCase()
             
            return ( <CommonHeader isFirstLogin={isFirstLogin} isTokenExists={isTokenExists} />); 
        }else{
            return (<Login x="ss"/>);
        } 
    }
 
}
